import React, { useState } from 'react';
import { Icon, Typography } from 'antd';
import cn from 'classnames';
import { base64ToUint8Array } from '../../../../helpers/attachments/base64ToUint8Array';
import { isAsyncFn } from '../../utils/isAsyncFn';
import { useEvents } from '../../providers/events';
import RemoveFileBtn from '../RemoveFileBtn';
import { formatBytes } from '../../utils/formatBytes';
import { downloadAttachment } from '../../../../helpers/attachments/downloadAttachment';
import styles from './index.module.scss';

const FileComponent = ({ file, commentId, removeFile, index }) => {
  const { name } = file;

  const [isLoading, setIsLoading] = useState(false);

  const { getCommentAttachment } = useEvents();

  const downloadFile = async () => {
    let url;

    const isAsync = isAsyncFn(getCommentAttachment);

    switch (true) {
      case file instanceof File: {
        url = URL.createObjectURL(file);
        break;
      }

      case Boolean(isAsync && commentId): {
        setIsLoading(true);
        const data = await getCommentAttachment({
          fileName: file.fileName,
          commentId,
        });

        if (data !== 'Error') {
          const uint = base64ToUint8Array(data);
          url = URL.createObjectURL(new Blob([uint]));
        }

        setIsLoading(false);
        break;
      }

      case Boolean(!isAsync && commentId): {
        const data = getCommentAttachment({
          fileName: file.fileName,
          commentId,
        });
        const uint = base64ToUint8Array(data);
        url = URL.createObjectURL(new Blob([uint]));
        break;
      }

      default: {
        break;
      }
    }

    if (url) {
      downloadAttachment({ url, title: name });
      URL.revokeObjectURL(url);
    }
  };

  return (
    <div className={styles.file} onClick={downloadFile}>
      <div className={styles.fileIcon}>
        <Icon type={isLoading ? 'loading' : 'paper-clip'} />
      </div>

      <div className={styles.metaWrapper}>
        <Typography.Text className={styles.metaContent}>{name}</Typography.Text>
        {file.size && (
          <Typography.Text className={cn(styles.metaContent, styles.fileSize)}>
            {formatBytes(file.size)}
          </Typography.Text>
        )}
      </div>

      {typeof removeFile === 'function' && (
        <RemoveFileBtn
          className={styles.deleteFile}
          onClick={() => removeFile(index)}
        />
      )}
    </div>
  );
};

export default FileComponent;
